import { Base } from 'src/api/Base'

export class EnterpriseAPI extends Base {
  static get entity() {
    return 'enterprise'
  }

  static async getReports() {
    const { dealerGroupId } = this.datepicker
    const params = {
      dealerGroupId,
    }
    const { data } = await this.request().get(`/${this.entity}/reports`, {
      params,
    })
    return data
  }

  static async updateReport({ isGlobal = false, name, dealerships, metrics, orderBy, reportId }) {
    const { dealerGroupId } = this.datepicker
    const params = {
      dealerGroupId,
      reportId,
    }
    const body = {
      isGlobal: Number(isGlobal),
      name,
      dealerships,
      metrics,
      orderBy,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    })
      .post(`${this.entity}/update-report`, body, {
        params,
      })
      .catch((resp) => resp.response)

    return data
  }

  static async addReport({ isGlobal = false, name, dealerships, metrics, orderBy }) {
    const { dealerGroupId } = this.datepicker
    const params = {
      dealerGroupId,
    }
    const body = {
      isGlobal: Number(isGlobal),
      name,
      dealerships,
      metrics,
      orderBy,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    })
      .post(`${this.entity}/add-report`, body, {
        params,
      })
      .catch((resp) => resp.response)

    return data
  }

  static async export({ metrics, dealerships, comparison, format, percentages = false, orderby }) {
    const options = this.normalizeOptions({
      comparison,
      percentages: Number(percentages),
      orderby,
    })
    const params = {
      ...this.datepicker,
      ...options,
      format,
      dealerships: dealerships.join(','),
      metrics,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).get(`${this.entity}/export`, {
      params,
    })

    return data
  }
}
